import React from 'react';
import { motion } from 'framer-motion';

const clients = [
  { name: 'OnePlus', url: 'https://www.oneplus.com', color: '#EB0028' },
  { name: 'Masai School', url: 'https://www.masaischool.com', color: '#1B75BB' },
  { name: 'Wispr Flow', url: 'https://wisprflow.ai', color: '#6C63FF' },
  { name: 'Kookar AI', url: 'https://www.kookar.in', color: '#FF6B35' },
  { name: 'AskBud-i', url: 'https://askbud-i.com', color: '#2ECC71' },
  { name: 'Unboxify', url: 'https://www.unboxify.in', color: '#E74C3C' },
  { name: 'Maximize', url: '#', color: '#F39C12' },
];

const ClientLogos = () => {
  const allClients = [...clients, ...clients];

  return (
    <section className="relative py-10" style={{ background: 'white', zIndex: 50 }}>
      <p
        className="text-center text-xs tracking-widest uppercase mb-8"
        style={{ color: '#122F26', opacity: 0.35, letterSpacing: '0.25em' }}
      >
        Trusted by &amp; worked with
      </p>

      <div className="relative w-full overflow-hidden">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to right, white, transparent)' }} />
        <div className="absolute right-0 top-0 bottom-0 w-20 z-10" style={{ background: 'linear-gradient(to left, white, transparent)' }} />

        <motion.div
          className="flex items-center gap-14 md:gap-20"
          animate={{ x: ['0%', '-50%'] }}
          transition={{
            x: {
              duration: 25,
              repeat: Infinity,
              ease: 'linear',
            },
          }}
          style={{ width: 'max-content' }}
        >
          {allClients.map((client, index) => (
            <a
              key={`${client.name}-${index}`}
              href={client.url}
              target={client.url !== '#' ? '_blank' : undefined}
              rel="noopener noreferrer"
              className="flex-shrink-0 flex items-center gap-2 group"
            >
              {/* Color dot */}
              <span
                className="w-2.5 h-2.5 rounded-full flex-shrink-0 transition-transform group-hover:scale-150"
                style={{ background: client.color }}
              />
              <span
                className="text-base md:text-lg font-semibold tracking-tight transition-all duration-300 group-hover:opacity-100"
                style={{
                  color: '#122F26',
                  opacity: 0.5,
                }}
              >
                {client.name}
              </span>
            </a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientLogos;
